export default __webpack_public_path__ + "static/media/work-orders-inactive-icon.5be36e50.svg";